import React, { InputHTMLAttributes, useMemo } from 'react';
import { shouldShowError } from './utils';

export type EditableInputProps = InputHTMLAttributes<HTMLInputElement> & {
  isEditing: boolean;
  showError?: boolean;
};

const EditableInput: React.FC<EditableInputProps> = ({
  isEditing,
  className = '',
  showError = false,
  ...inputProps
}) => {
  const value = String(inputProps.value || '');

  const hasError = useMemo(
    () => shouldShowError(value, inputProps.type, showError),
    [value, inputProps.type, showError]
  );

  const displayValue = useMemo(() => {
    if (value === '') {
      return '-';
    }
    return value;
  }, [value]);

  const inputClassName = useMemo(
    () =>
      `w-full border ${
        hasError ? 'border-red-5' : 'border-[#96999C]'
      } bg-white p-2 rounded focus:ring-2 ${
        hasError ? 'focus:ring-red-500' : 'focus:ring-blue-500'
      } focus:outline-none ${className}`,
    [hasError, className]
  );

  const spanClassName = useMemo(
    () =>
      hasError ? 'text-red-5 border border-red-5 p-2 rounded inline-block w-full max-w-36' : '',
    [hasError]
  );

  if (!isEditing) {
    return <span className={spanClassName}>{displayValue}</span>;
  }

  return <input {...inputProps} className={inputClassName} />;
};

export default EditableInput;
